import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/codebuild/output/src3517620116/src/webapp/src/components/features/auth/forgot-password/forgot-password-form.tsx");
